var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"font-weight-bold",attrs:{"href":"#"},on:{"click":function($event){return _vm.openTicketForm()}}},[_vm._v(" "+_vm._s(_vm.linkText ? _vm.linkText : _vm.fullEmailAddress)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }